"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.versionController = void 0;
const endpoints_1 = require("../../../constants/endpoints");
const typescriptHacks_1 = require("../../../helper/typescriptHacks");
const apiPath = endpoints_1.endpoints.version;
const versionController = (service) => ({
    create: (item) => {
        return service.post(apiPath, item, service.addAccessTokenToHeaders);
    },
    createSearch: (item) => __awaiter(void 0, void 0, void 0, function* () {
        const apiResult = yield service.post(`${apiPath}/Search`, item, service.addAccessTokenToHeaders);
        return apiResult.value;
    }),
    createNotification: (winGuid) => {
        return service.post(`${endpoints_1.endpoints.versionSendUpdateNotification}/${winGuid}`, typescriptHacks_1.anyObject, service.addAccessTokenToHeaders);
    },
    readLatest: (appGuid) => {
        return service.get(`${apiPath}/${appGuid}`);
    },
    readAllForAdmin: () => {
        return service.get(`${apiPath}/Admin`, service.addAccessTokenToHeaders);
    },
    readAllHistory: (appGuid, langGuid, platforms, page) => {
        let url = `${apiPath}/${appGuid}/${langGuid}`;
        if (platforms != null) {
            let queryParamStr = '';
            for (const platform of platforms) {
                if (queryParamStr.length > 1) {
                    queryParamStr += '&';
                }
                else {
                    queryParamStr += '?';
                }
                queryParamStr += `platforms=${platform}`;
            }
            url += queryParamStr;
        }
        if (page != null) {
            if (url.includes('?')) {
                url += `?page=${page}`;
            }
            else {
                url += `&page=${page}`;
            }
        }
        return service.get(url, service.addAccessTokenToHeaders);
    },
    update: (item) => {
        return service.put(apiPath, item, service.addAccessTokenToHeaders);
    },
    del: (appGuid) => {
        return service.delete(`${apiPath}/${appGuid}`, service.addAccessTokenToHeaders);
    }
});
exports.versionController = versionController;
